import { Text } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	DataKYCFileTctWithFile,
	GetKYCInvestorInstanceRes,
	KYCFileType,
} from '@dealstack/shared/lib/generated';
import { FormReviewCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/FormReviewCard';
import {
	Container,
	Inner,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/styled';
import { AddKycFileButton } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/AddKycFileButton';
import { Step } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';

interface Props {
	currentStep: Step;
	currentInvestor?: GetKYCInvestorInstanceRes;
	selectedKycFileId?: string;
	onSelectFile: (kycFile: DataKYCFileTctWithFile) => void;
	isReadOnly?: boolean;
}

export const PivCardList = ({
	currentStep,
	currentInvestor,
	selectedKycFileId,
	onSelectFile,
	isReadOnly = false,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	const pivFiles =
		currentInvestor?.kycFiles?.filter(
			(file) => file.type === KYCFileType.INVESTMENT_VEHICLE && !file.deleted
		) ?? [];

	return (
		<Container>
			<Inner>
				{pivFiles.length === 0 && (
					<Text size="B6" c="dark.2">
						{tMipManage('kyc.review.piv.no_files')}
					</Text>
				)}

				{pivFiles.map((kycFile) => (
					<FormReviewCard
						key={kycFile.id}
						primaryText={kycFile.file?.name ?? ''}
						kycFile={kycFile}
						kycHistory={currentInvestor?.kycHistory}
						isSelected={kycFile.id === selectedKycFileId}
						onClick={() => onSelectFile(kycFile)}
					/>
				))}

				{!isReadOnly && (
					<AddKycFileButton currentStep={currentStep} currentInvestor={currentInvestor} />
				)}
			</Inner>
		</Container>
	);
};
